import React, { FC, memo } from 'react';
import CustomField from '@components/form/CustomField';
import TextInput from '@components/form/TextInput';
import RadioGroup from '@components/form/RadioGroup';
import Select from '@components/form/Select';
import { Field } from '@/types';
import ControlledNumericInput from '@components/form/ControlledNumericInput';
import ControlledSwitch from '@components/form/ControlledSwitch';
import FileUploader from '@components/form/file-uploader/FileUploader';
import Checkbox from '@components/form/Checkbox';

interface Props {
  inputs: Field[];
  form?:any;
}

const FIELDS_MAPPING = {
  number: ControlledNumericInput,
  integer: ControlledNumericInput,
  float: ControlledNumericInput,
  tel: TextInput,
  date: TextInput,
  email: TextInput,
  text: TextInput,
  checkbox: Checkbox,
  radio: RadioGroup,
  select: Select,
  custom: CustomField,
  array: CustomField,
  switch: ControlledSwitch,
  file: FileUploader,
};

const Form: FC<Props> = ({ inputs,form }) => {
  return (
    <div className="flex flex-col w-full">
      {inputs.map(({ type, name, model, ...q }: any, i: number) => {
        const Component = FIELDS_MAPPING[type as keyof typeof FIELDS_MAPPING];

        // Pages like energy_report have no form field type; skip instead of showing an error.
        if (!Component) return null;

        const isFirstComponent = i === 0;

        return <Component form={form} autoFocus={isFirstComponent} key={name} name={name} model={model} type={type} {...q} />;
      })}
    </div>
  );
};

export default memo(Form);
